<template>
  <LayoutGradient :title="this.$t('reportControl.form.titulo_pagina.editar')" icon="fa-control">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.push({ name: 'vns.report_control'})">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">      
      <b-form @submit="onSubmit">
        <b-form-group
          :label="$t('reportControl.form.fields.vns.label')"
          label-for="input-vns"
          :description="$t('reportControl.form.fields.vns.description')"
        >
          <b-overlay :show="store_vnss_loading">
            <SelectComponent
                  id="input-vns"
                  :model="vns"
                  :options="store_vnss | idNameToValueLabel"
                  @search="evt => {autocomplete('vns', evt)}"
                  @input="evt => reloadPage(evt)"
              />
          </b-overlay>
        </b-form-group>
        <b-form-group
          :label="$t('reportControl.form.fields.report_control.label')"
          label-for="input-report-control"
          :description="$t('reportControl.form.fields.report_control.description')"
        >
          <b-input-group>
            <b-input-group-prepend>
              <b-button
                  variant="outline-success"
                  @click="addElement('addVnsReportControl', {id: null, name: inputReportControl})">
                <i class="fas fa-plus"/></b-button>
            </b-input-group-prepend>
            <b-form-input id="input-report-control" v-model="inputReportControl" @keydown.enter.prevent="" @keyup.enter="addElement('addVnsReportControl', {id: null, name: inputReportControl})"/>
          </b-input-group>
          <b-table v-if="controls && controls.length > 0"
                    thead-class="d-none"
                    :fields="['id','name']"
                    :items="controls"
                    tbody-tr-class="float-left">
            <template v-slot:cell(id)="linha">
              <b-button
                  variant="outline-danger"
                  @click="removeElement('addVnsReportControl', linha.item); removeElementDb('reportControls', linha.item);"
                  pill><i class="fas fa-minus"/>
              </b-button>
            </template>
          </b-table>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('reportControl.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import ReportControlRepository from '@/repositories/vns/ReportControlRepository'
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient,
    SelectComponent
  },
  data() {
    return {
      vnsId: null,
      addVnsReportControl: [],
      inputReportControl: ''
    }
  },
  computed: {
    ...mapGetters({
      reportControls: 'reportControl/allByVns',
      isLoading: 'reportControl/isLoading',
      store_vnss: 'vns/all',
      store_vnss_loading: 'vns/isLoading',
    }),
    vns() {
      if (this.vnsId && this.store_vnss) {
        const model = this.store_vnss.find(c => this.vnsId === c.id)
        if (model) {
          return {
            value: model.id,
            label: model.name
          }
        }        
      }
      return {}
    },
    controls() {
      let vnsReportControl =  this.reportControls.vnsReportControl.map((control) => {
        return {          
          id: control.id,
          name: control.report_control
        }
      });

      return vnsReportControl.concat(this.addVnsReportControl);
    }
  },
  methods: {
    ...mapActions([
      'reportControl/listByVns',
      'vns/listAll',
      'vns/search'
    ]),
    async reloadPage(evt) {
      this.vnsId = evt.value;
      this.addVnsReportControl = [];
      this.inputReportControl = '';
      this.$router.push({ name: 'vns.report_control.edit', params: { id: evt.value } });      
      await this['reportControl/listByVns'](this.vnsId)
    },
    addElement(array, element) {
      this[array] = [...this[array], element];
      this.inputReportControl = '';
    },
    removeElement(array, element) {
      this[array] = this[array].filter(e => {
        return e !== element
      })
    },
    removeElementDb(array, element) {
      this[array].vnsReportControl = this[array].vnsReportControl.filter(e => {
        return e.report_control !== element.name
      })
    },
    async onSubmit(evt) {
      evt.preventDefault()
      this.update()
    },
    update() {
      ReportControlRepository.postByVns(this.vnsId, {controls: this.controls.map(t => {return t.name;})}).then(response => {
        this.$snotify.success(this.$t('reportControl.form.update.success'))
        this.$router.push({name: 'vns.report_control'})
      }).catch(error => {
        this.$snotify.error(this.$t('reportControl.form.update.error'))
        if (error.response.status === 422) {
          ReportControlRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    async autocomplete(entityString, string) {
      if (string && string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          this.temporallyStringPrepareToSQL('name', string).map(async array => {
            await this[`${entityString}/search`]({filters: [array, ['status', '=', true]]})
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    temporallyStringPrepareToSQL(field, valueTyped) {
      return [
        [field, 'LIKE', '%' + valueTyped + '%']        
      ];
    }
  },
  async mounted() {
    await this['reportControl/listByVns'](this.$route.params.id)
    await this['vns/listAll']()
    this.vnsId = this.$route.params.id    
  }
}
</script>

<style lang="scss" scoped>
</style>
